import { ChangeEvent } from 'react';
import './Checkbox.css';

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/**
 * Reusable checkbox component with label
 * @param label - The label text
 * @param checked - Whether the checkbox is checked
 * @param onChange - Callback when state changes
 * @param disabled - Whether the checkbox is disabled
 * @returns The rendered checkbox component
 */
function Checkbox({ label, checked, onChange, disabled = false }: CheckboxProps): JSX.Element {
  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    onChange(e.target.checked);
  };

  return (
    <label className={`checkbox ${disabled ? 'checkbox--disabled' : ''}`}>
      <input
        type="checkbox"
        className="checkbox-input"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <span className="checkbox-box">
        {checked && <i className="fas fa-check"></i>}
      </span>
      <span className="checkbox-label">{label}</span>
    </label>
  );
}

export default Checkbox;
